import { WebAssistantWorkspace } from "@/shared/assistant/WebAssistantWorkspace";

export function DashboardPage() {
  return (
    <div data-testid="page-dashboard" style={{ height: "100%" }}>
      <WebAssistantWorkspace />
    </div>
  );
}
